<div
  role="button"
  tabindex="-1"
  class="ui-icon relative {{ disabled ? 'disabled' : '' }} {{ filterAnimation ? 'filterAnimation' : '' }}"
  (click)="onClickEvent($event)"
>
  <mat-icon [ngStyle]="{ width: size, height: size }" *ngIf="!!icon" [svgIcon]="icon"></mat-icon>
  <ng-content></ng-content>
</div>
